import script from "./MainFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFooter.vue?vue&type=script&setup=true&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=5c946f0e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c946f0e"]])

export default __exports__